import * as React from 'react'
import Stack from '@mui/material/Stack'
import { useData } from './hooks'
import Typography from '@mui/material/Typography'

type BaseProps = {
  highlight?: boolean
  highlightColor: string
  name: string
  searchText: string
  sectionStart?: boolean
}

type StringProps = {
  value: string
  variant: 'string' | 'phone'
}

type ArrayProps = {
  value: string[]
  variant: 'array'
}

type CurrencyProps = {
  value: number
  variant: 'currency'
}

export type Props = BaseProps & (StringProps | ArrayProps | CurrencyProps)

export function NameValue(props: Props) {
  const { name, sectionStart = false, value, variant } = props

  const { valueFormatted } = useData(props)

  return (
    <Stack
      direction="row"
      mt={sectionStart ? 1 : undefined}
      alignItems="flex-start"
    >
      {(variant !== 'currency' && value) ||
      variant === 'currency' ||
      value?.length > 0 ? (
        <>
          <Typography variant="subtitle2">
            {name}
            {':\u00A0'}
          </Typography>
          <Typography variant="body2" mt={0.1}>
            {valueFormatted}
          </Typography>
        </>
      ) : null}
    </Stack>
  )
}
